/**
 * Client detail daily summary rows for the ClientDetailPage.
 * Hardcoded fixture mirroring skill-test's ClientDetail data,
 * representing daily activity breakdown for a single client.
 *
 * All dates are relative to FROZEN_NOW and fall within Mar 2026.
 */

import { FROZEN_NOW_MS } from '@/lib/frozenTime';

const DAY_MS = 24 * 60 * 60 * 1000;
const iso = (daysAgo: number): string => new Date(FROZEN_NOW_MS - daysAgo * DAY_MS).toISOString();

export interface ClientDailyRow {
  date: string; // ISO string
  hours: number;
  billable: number;
  general: number;
  firstActivity: string;
  lastActivity: string;
}

export const CLIENT_DAILY_ROWS: readonly ClientDailyRow[] = [
  {
    date: iso(16),
    hours: 7.8,
    billable: 7.8,
    general: 0,
    firstActivity: '8:42 AM',
    lastActivity: '5:18 PM',
  },
  {
    date: iso(17),
    hours: 6.5,
    billable: 6.5,
    general: 0,
    firstActivity: '9:15 AM',
    lastActivity: '4:45 PM',
  },
  {
    date: iso(18),
    hours: 8.2,
    billable: 8.2,
    general: 0,
    firstActivity: '8:30 AM',
    lastActivity: '6:12 PM',
  },
  {
    date: iso(19),
    hours: 3.1,
    billable: 3.1,
    general: 0,
    firstActivity: '10:00 AM',
    lastActivity: '1:45 PM',
  },
  {
    date: iso(20),
    hours: 7.0,
    billable: 7.0,
    general: 0,
    firstActivity: '8:55 AM',
    lastActivity: '5:30 PM',
  },
  {
    date: iso(23),
    hours: 5.8,
    billable: 5.8,
    general: 0,
    firstActivity: '9:30 AM',
    lastActivity: '4:15 PM',
  },
  {
    date: iso(24),
    hours: 7.2,
    billable: 7.2,
    general: 0,
    firstActivity: '8:15 AM',
    lastActivity: '5:00 PM',
  },
  {
    date: iso(25),
    hours: 2.5,
    billable: 2.5,
    general: 0,
    firstActivity: '1:00 PM',
    lastActivity: '3:30 PM',
  },
  {
    date: iso(26),
    hours: 6.0,
    billable: 6.0,
    general: 0,
    firstActivity: '9:00 AM',
    lastActivity: '4:00 PM',
  },
  {
    date: iso(27),
    hours: 4.2,
    billable: 4.2,
    general: 0,
    firstActivity: '10:30 AM',
    lastActivity: '3:15 PM',
  },
  {
    date: iso(30),
    hours: 1.5,
    billable: 1.5,
    general: 0,
    firstActivity: '2:00 PM',
    lastActivity: '3:30 PM',
  },
  {
    date: iso(31),
    hours: 0.8,
    billable: 0.8,
    general: 0,
    firstActivity: '11:00 AM',
    lastActivity: '11:45 AM',
  },
  {
    date: iso(32),
    hours: 0.5,
    billable: 0.5,
    general: 0,
    firstActivity: '3:00 PM',
    lastActivity: '3:30 PM',
  },
  {
    date: iso(33),
    hours: 0.7,
    billable: 0.7,
    general: 0,
    firstActivity: '9:00 AM',
    lastActivity: '9:42 AM',
  },
  {
    date: iso(34),
    hours: 0.5,
    billable: 0.5,
    general: 0,
    firstActivity: '4:00 PM',
    lastActivity: '4:30 PM',
  },
];
